import { AxiosResponse } from 'axios';
import axios from '../../../axios';
import { ClubData } from './club.interface';

const getDataClub = (subdomain: string): Promise<AxiosResponse<ClubData>> => {
  return axios.get(`/v1/clubs/${subdomain}`);
};

export { getDataClub };
